/**
 * Type for the category option structure
 */
export type CategoryOption = {
  section_name: string;
  fields: string[];
};

/**
 * Default category options used across the application
 */
export const DEFAULT_CATEGORY_OPTIONS: CategoryOption[] = [
  {
    section_name: "Frais de compte",
    fields: ["fees"],
  },
  {
    section_name: "Revenue",
    fields: ["accrued_interest"],
  },
  {
    section_name: "Fonds d'actifs non cotés",
    fields: [
      "capital_call",
      "capital_gain",
      "recallable_capital_gain",
      "distribution",
    ],
  },
];

export type movementMap = Record<string, string[]>;

export const DEFAULT_MOVEMENT_MAP: movementMap = {
  private_equity_fund: [
    "fees",
    "capital_call",
    "capital_gain",
    "recallable_capital_gain",
    "distribution",
  ],
  real_estate_fund: ["capital_call", "capital_gain", "distribution"],
  fct: ["accrued_interest", "capital_call", "capital_gain", "distribution"],
  short_term_bond: ["accrued_interest"],
  bond: ["accrued_interest"],
};
